import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { YesCancelModalComponent } from '../../modals/yes-cancel-modal/yes-cancel-modal.component';
import { AuthorizeService } from 'core-lib';
import { PermitService } from '../../services/permit.service';

@Component({
  selector: 'cli-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public vm: NavbarViewModel;

  @Input()
  public businessName: string;
  @Input()
  public contactName: string;
  @Input()
  public permitNo: string;
  @Input()
  public selectedSection: string;
  
  @ViewChild('logoutModal')
  public modal: YesCancelModalComponent;

  constructor(private router: Router,
              private permitSvc: PermitService,
              private authorizeSvc: AuthorizeService ) {
    this.vm = new NavbarViewModel();
   }

  ngOnInit() {
  }

  
  
  public logout() {
    this.modal.openModal().subscribe((r: string) => {
      if (r !== 'Yes') { return; }

      this.vm.isLoading = true;
      this.permitSvc.model = null;
      this.authorizeSvc.logout();
  
      this.router.navigate(['login']);
    },
      (e: any) => {
        this.modal.closeModal();
      });
  }

}

class NavbarViewModel{

   public isLoading : boolean;

}